module.exports = __webpack_public_path__ + "static/media/fotografia.29d61685.jpg";